export default [
  {
    name: 'show_colaboration',
    description: 'Esconde acessos para novas colaborações ',
    displayChildren: false
  }
];
